<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ayahPath, surahPath } from '@/utils/quran/paths';

/** The passages people open most, one tap away. */
defineProps({ tone: { type: String, default: 'light' } });

const { t } = useI18n();

const links = computed(() => [
  { to: surahPath(1), label: 'Al-Fatiha' },
  { to: ayahPath(2, 255), label: t('quran.quick.ayatulKursi') },
  { to: surahPath(18), label: 'Al-Kahf' },
  { to: surahPath(36), label: 'Ya-Sin' },
  { to: surahPath(55), label: 'Ar-Rahman' },
  { to: surahPath(67), label: 'Al-Mulk' },
  { to: ayahPath(2, 286), label: t('quran.quick.lastOfBaqarah') },
]);
</script>

<template>
  <ul class="flex flex-wrap gap-2" :aria-label="t('quran.quick.label')">
    <li v-for="link in links" :key="link.label">
      <router-link
        :to="link.to"
        :class="[
          'inline-flex items-center h-9 px-3.5 rounded-xl text-sm font-semibold transition-all',
          tone === 'light'
            ? 'bg-white border border-deen-ink/10 text-deen-ink/70 hover:text-deen-ink hover:border-deen-ink/25 hover:shadow-sm'
            : 'bg-white/10 border border-white/15 text-white/80 hover:bg-white/20',
        ]"
      >
        {{ link.label }}
      </router-link>
    </li>
  </ul>
</template>
